export class UpdateSubjectModel {

    "questionId": Number;
    "createdDate": Number;
    "userId": Number;
    "patientId": String;
    "studyId": Number;
    "sectionId": Number;
    "answer": String;
    "remarks": String;
}